<script>
import { mapActions, mapState } from 'pinia';
import { orderStore } from '../../../stores/order';
import { useEventBus } from '../../../stores/eventBus.js';
import DeliveryTabs from '@/components/order-vue/order/components/tabs/DeliveryTabs.vue';

export default {
	components: {
		DeliveryTabs
	},
	
	computed: {
		...mapState(orderStore, ['deliverySystems', 'currentLocationData', 'currentDeliverySystem', 'addressFieldsMap']),
	},

	mounted() {
		useEventBus().subscribe('o2k:user.city.select:orderLocationSelectPopupLocationChange', this.changeLocationHandler.bind(this));
	},

	methods: {
		...mapActions(orderStore, {selectDelivery: 'changeDelivery', selectLocation: 'changeLocation'}),

		changeLocationHandler(event) {
			const bxLocationCode = event.data.bxLocationCode;
			this.selectLocation(bxLocationCode);
		}
	},
};
</script>

<template>
	<div
		id="bx-soa-delivery"
		class="checkout-obtain checkout-item"
	>
		<h3 class="checkout-item__title">{{ $loc.get('DELIVERY_TITLE') }}</h3>
		<div class="checkout-item__wrapper">
			
			<template v-if="deliverySystems.length > 0">
				<DeliveryTabs />
			</template>
			
			<input
				v-if="addressFieldsMap.location"
				type="hidden"
				:name="'ORDER_PROP_' + addressFieldsMap.location?.id"
				:value="currentLocationData?.bxLocCode"
			>
		</div>
	</div>
</template>

<style scoped>

</style>
